<template>
    <div>
            <Row style="padding-bottom: 30px">
                <Col span="5" >
                    <DatePicker
                            split-panels
                            type="daterange"
                            :options="options"
                            placeholder="选择日期"
                            @on-change="handleOk"
                            :value="valuedate"
                           >
                    </DatePicker>
                </Col>
            </Row>
            <Row style="padding-bottom: 10px">
                <Col span="12" align="center">总充值金额</Col>
                <Col span="12" align="center">总赠送金额</Col>
                <Col span="12" align="center">{{allMoney.money}}</Col>
                <Col span="12" align="center">{{allMoney.gmoney}}</Col>
            </Row>
         <ul class="recharge-item" style="overflow: auto; max-height: 500px">
             <li v-for="(k,v) in getData">
                 <img src="../../assets/img/index/daili.png">
                 <Row>
                     <Col span="17">{{k.customerName}}</Col>
                     <Col span="7">充值金额:<span style="color: #4673e6">{{k.money}}</span></Col>
                     <Col span="17" style="color: #666666">{{k.endTime}}</Col>
                     <Col span="7">赠送总额:{{k.gmoney}}</Col>
                 </Row>
                 <span class="shop">{{k.shopName}}</span>
             </li>
         </ul>
    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                getData:[],
                allMoney:{},
                cid: "",
                page:1,
                rows:10,
                options: {
                    shortcuts: [
                        {
                            text: '过去一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '过去一月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '过去三月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ],
                }
            }
        },
        mounted: function () {
            //DOM更新完后再请求数据
            this.$nextTick(function () {


            });
        },
        created: function () {
            //DOM更新完之前请求数据
            let data= JSON.parse(localStorage.getItem('adminUser'))
            this.cid=data.cid

            this.valuedate[0] = this.nowTime
            this.valuedate[1] = this.nowTime
            this.getSelectMemberLogWaterGroup(this.cid, this.page, this.rows, this.valuedate[0], this.valuedate[1])

        },
        methods: {
            //查询总金额
            countMoney(cid,endTime,startTime){
                this.$Api.countMoney({
                    cid: cid,
                    endtime:endTime,
                    staretime: startTime,
                }).then(res => {
                    if(res.code==200){
                       this.allMoney = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //查询列表
           getSelectMemberLogWaterGroup(cid,page,rows,startTime,endTime){
               let data = {
                   cid: cid,
                   customerId: undefined,
                   endTime:endTime,
                   startTime: startTime,
                   page: page,
                   rows: rows,
                   sid: undefined,
               };
               this.$Api.selectMemberLogWaterGroup(data).then(res => {
                   if(res.code==200){
                       this.getData = res.data
                       this.countMoney(data.cid,data.startTime, data.endTime)
                   }else {
                       this.$Message.warning(res.msg);
                   }
               });
           },
            handleOk(data){
                 this.getSelectMemberLogWaterGroup(this.cid,this.page,this.rows,data[0],data[1])
            }

        }
    }
</script>
<style lang="scss" scoped>
    .server-title {
        display: inline-block;
        text-align: center;
        width: 88%
    }
    .recharge-item{
        li{
            width: 100%;
            height: 101px;
            border-bottom: 1px solid #dfdfdf;
            position: relative;
            padding: 35px 10px 0 70px;
            .shop{
                display: block;
                width: 70px;
                height: 24px;
                background-color: #2d70f7;
                border-radius: 0 0px 0px 18px;
                text-align: center;
                line-height: 24px;
                color: #ffffff;
                font-size: 12px;
                position: absolute;
                top: 0;
                right: 0;
            }
            img{
                position: absolute;
                top: 50%;
                left: 30px;
                margin-top: -13px;
            }
        }
        li:first-child{
            border-top: 1px solid #dfdfdf;
        }
    }
</style>